<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/global-bg.png" />
    <div>
      <div class="list no-padding">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">公司整体目标分解到渠道</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart05M id="global03" :datas="data01" :colors="colors" height="240px"/>
      </div>
      <div class="list no-padding">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">公司整体目标分解到渠道季度</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <!-- <Echart05M id="global04" :datas="data02" :colors="colors" height="240px"/> -->
        <Echart07M02 id="global04" :datas="data02" :items="items" :dimensions="dimensions" height="320px" />
      </div>
      <div class="list">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">公司整体目标分解到渠道月度</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart07M02 id="global05" :datas="data03" :items="items" :dimensions="dimensions" height="800px" />
      </div>
    </div>
    <NavStyle :navIndex="2"></NavStyle>
  </div>
</template>

<script>
  import Echart05M from '../../components/Echart05M.vue'
  import Echart07M02 from '../../components/Echart07M02.vue'
  import NavStyle from '../../components/NavStyle.vue'
  
  export default {
    name: 'GlobalY',
    components: {
      Echart05M,
      Echart07M02,
      NavStyle
    },
    data() {
      return {
        loading: false,
        colors: [ '#2dfcff','#ffda2d','#be2dfa','#fff',],
        data: [],
        // data01: [
        //   { value: 100910, name: '统招类' },
        //   { value: 80000, name: '运作类' },
        //   { value: 20000, name: '渠道拓展' },
        //   { value: 3500, name: '行业外' }
        // ],
        // data02: [
        //   {name: "第一季度", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "第二季度", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "第三季度", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "第四季度", value1: 5, value2: 6, value3: 4, value4: 1},
        // ].reverse(),
        items: ['统招类', '运作类', '渠道拓展', '行业外'],
        dimensions: ['name', 'value1', 'value2', 'value3', 'value4'],
        // data03: [
        //   {name: "1月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "2月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "3月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "4月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "5月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "6月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "7月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "8月", value1: 5, value2: 6, value3: 4, value4: 1},
        //   {name: "9月", value1: 5, value2: 6, value3: 4, value4: 1},
        //  {name: "10月", value1: 5, value2: 6, value3: 4, value4: 1},
        //  {name: "11月", value1: 5, value2: 6, value3: 4, value4: 1},
        //  {name: "12月", value1: 5, value2: 6, value3: 4, value4: 1},
        // ].reverse()
      }
    },
    mounted() {
      this.$axios.post('/annual_route/findList').then( res => {
        let arr = []
        res.data.data.map(item => {
          arr.push({name: item.timer, value1: item.tz, value2: item.yz, value3: item.qdtz, value4: item.hyw})
        })
        this.data = arr
      })
    },
    computed: {
      data01() {
        let obj = this.data[16] || []
        return [
          { value: obj.value1, name: '统招类' },
          { value: obj.value2, name: '运作类' },
          { value: obj.value3, name: '渠道拓展' },
          { value: obj.value4, name: '行业外' }
        ]
      },
      data02() {
        return this.data.slice(12, 16).reverse()
      },
      data03() {
        return this.data.slice(0, 12).reverse()
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .list {
    padding-bottom: 40px;
  }
  
  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }
  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }
  
  .icon-cur{
    color: white;
    background-color: #1fd6d9;
  }
  
  .title-cont01 {
    margin-bottom: 20px
  }
  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .echart-box > div {
    width: 50%;
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
  .no-padding {
    padding: 0 !important;
  }
</style>
